import React, { Component } from 'react';
import {DraggableWindow} from '../DraggableWindow';

import { LayoutContext } from '../../../../modules/ContextModules/LayoutContext';
import { MeasureItem } from './MeasureItem/MeasureItem';

import 平面距離測量Img from './.image/平面距離測量.png'
import 空間距離測量Img from './.image/空間距離測量.png'
import 垂直高度測量Img from './.image/垂直高度測量.png'
import 區域面積測量Img from './.image/區域面積測量.png'
import 清除測量標記Img from './.image/清除測量標記.png'

import './MeasureTool.css'
export class MeasureTool extends Component {
    static contextType = LayoutContext;
    constructor(props) {
        super(props);

        this.state = {
        }

        this.list = [
            {
                name: "平面距離測量",
                icon: 平面距離測量Img,
            },
            {
                name: "空間距離測量",
                icon: 空間距離測量Img,
            },
            {
                name: "垂直高度測量",
                icon: 垂直高度測量Img,
            },
            {
                name: "區域面積測量",
                icon: 區域面積測量Img,
            },
            {
                name: "清除測量標記",
                icon: 清除測量標記Img,
            },            
        ]
    }

    componentDidMount() {
    }

    render() {
        // 在 render 中將可以使用 this.context
        return (
            <DraggableWindow 
            header="測量工具" 
            content={this.content()} 
            width={this.props.width}
            height={this.props.height}
            defaultPosition={this.props.defaultPosition}
            handleMinimize={this.props.handleMinimize}
            handleCancel={this.props.handleCancel}
            isShow={this.props.isShow} />
        );
    }

    content() {
        return (
            <div className='measureTool'>
                {
                    this.list.map(item=>{
                        return <MeasureItem key={item.name} data={item} handleClick={this.handleClick}/>
                    })
                }
            </div>
        );
    }

    handleClick = (data) => {
        switch(data.name) {
            case "平面距離測量": {
                window.gMainMap.TerrainView.abortInput();
                window.alertify.log("平面距離測量中，單擊左鍵選取起點，雙擊左鍵選取終點。");
                window.gMainMap.TerrainView.measureSurfaceLength({onCompleted:()=>{}});
            }
            break;
            case "空間距離測量": {
                window.gMainMap.TerrainView.abortInput();
                window.alertify.log("空間距離測量中，單擊左鍵選取起點，雙擊左鍵選取終點。");
                window.gMainMap.TerrainView.measureSpatialLength({onCompleted:()=>{}});                
            }
            break;
            case "垂直高度測量": {
                window.gMainMap.TerrainView.abortInput();
                window.alertify.log("高度測量中，單擊滑鼠左鍵選取起終點。");
                window.gMainMap.TerrainView.measureHeight({onCompleted:()=>{}});
            }
            break;
            case "區域面積測量": {
                window.gMainMap.TerrainView.abortInput();
                window.alertify.log("區域面積測量中，單擊左鍵選取起點，雙擊左鍵完成繪製。");
                window.gMainMap.TerrainView.measureArea({onCompleted:()=>{}});
            }
            break;
            case "清除測量標記": {
                window.gMainMap.TerrainView.clearMeasure({onCompleted:()=>{
                    window.alertify.success("已清除測量標記。");
                }});
            }
            break;
        }
    }    

    //縮小視窗 暫用不到
    minimizeWindow = () => {
        this.state
        .draggableWindowContext
        .measureTool
        .update({
            isOpened: false,
        });
    }
}